import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { login } from "../../redux/actions/authActions";
import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

export default function LoginModal({ onClose, onSwitch, openForgotPassword }) {
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await dispatch(login(email, password));
      onClose(); // succès
      navigate("/dashboard");
    } catch (err) {
      setError(err.message || "Erreur lors de la connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="loginModalOverlay">
      <div className="loginModal">
        <button className="loginModalClose" onClick={onClose}>×</button>
        <h2>Connexion</h2>
        <form onSubmit={handleSubmit}>
          {/* Email */}
          <div className="loginModal-input-form">
            <label>Email</label>
            <input
              type="email"
              value={email}
              placeholder="Entrez votre email"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="loginModal-input-form">
            <label htmlFor="password">Mot de passe</label>
            <div className="password-wrapper">
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                value={password}
                placeholder="Votre mot de passe"
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
              <button
                type="button"
                className="togglePassword"
                aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                onClick={() => setShowPassword((v) => !v)}
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </button>
            </div>
          </div>

          {/* Erreur */}
          {error && <div className="loginModalError">{error}</div>}

          {/* Bouton submit */}
          <div className="loginModal-input-form">
            <button className="loginSubmitBtn" type="submit" disabled={loading}>
              {loading ? "Connexion..." : "Se connecter"}
            </button>
          </div>
        </form>
        <p className="modal-switch">
          Pas encore inscrit ?{" "}
          <span onClick={onSwitch}>
            Créer un compte
          </span>
        </p>
        <p className="modal-switch">
          Mot de passe oublié ?{" "}
          <span onClick={openForgotPassword}>
            Réinitialiser le mot de passe
          </span>
        </p>
      </div>
    </div>
  );
}
